import { Card } from "react-bootstrap";
import { MdError } from "react-icons/md";
import { useSelector } from "react-redux";

const ClaimIssueRequest = () => {
  const {
    validationErrors,
    validationWarning,
    viewClaimInfo,
  } = useSelector((state) => state.claim);

  const isTag = viewClaimInfo?.payer_response?.tag;

  const errorRemarkDetails = viewClaimInfo?.payer_response?.remarks;

  // Parse validation errors from provider_request.valdn_err
  const parseProviderValidationErrors = () => {
    const valdn_err = viewClaimInfo?.provider_request?.valdn_err;
    if (!valdn_err) return [];

    const errors = [];

    // Handle service errors
    if (valdn_err.service && Array.isArray(valdn_err.service)) {
      let currentLineNo = null;
      valdn_err.service.forEach((item) => {
        if (item.no !== undefined) {
          currentLineNo = item.no;
        }
        if (item.msg) {
          errors.push({
            type: "Error",
            message: `In Service No. ${currentLineNo || "Unknown"}: ${item.msg}`,
          });
          currentLineNo = null;
        }
      });
    }

    // Handle diagnosis errors
    if (valdn_err.diag?.msg) {
      errors.push({
        type: "Error",
        message: `Diagnosis: ${valdn_err.diag.msg}`,
      });
    }

    // Handle practitioner errors
    if (valdn_err.pract?.msg) {
      errors.push({
        type: "Error",
        message: `Practitioner: ${valdn_err.pract.msg}`,
      });
    }

    // Handle any other validation errors
    Object.keys(valdn_err).forEach((key) => {
      if (key !== 'service' && key !== 'diag' && key !== 'pract') {
        const error = valdn_err[key];
        if (error?.msg) {
          errors.push({
            type: "Error",
            message: `${key}: ${error.msg}`,
          });
        }
      }
    });

    return errors;
  };

  const providerValidationErrors = parseProviderValidationErrors();

  // Combine validation errors and warnings
  const allValidationIssues = [
    ...(validationErrors?.map((error) => ({
      type: "Error",
      message: error.message,
    })) || []),
    ...(validationWarning?.map((warning) => ({
      type: "Warning",
      message: warning.message,
    })) || []),
    ...providerValidationErrors,
  ];



  return (
    <div>
      <Card className="border-2 border-danger mb-3">
        <Card.Header className="text-danger badge-subtle-danger border-danger border-bottom rounded-top">
          <div className="d-flex fs-12 align-items-center">
            <MdError className="me-2" />
            <span>Remarks</span>
          </div>
        </Card.Header>
        <Card.Body>
          {/* Validation Errors/Warnings Section */}
          {allValidationIssues?.length > 0 && (
            <>
              <h6 className="text-danger fs-12 mb-2">Validation Issues</h6>
              <ul className="mb-3 list-number">
                {allValidationIssues?.map((item, index) => (
                  <li
                    key={`validation-${index}`}
                    className={`fs-12 ${item.type === "Error" ? "text-danger" : "text-warning"
                      }`}
                  >
                    {item.message}
                  </li>
                ))}
              </ul>
              <hr className="border-danger" />
            </>
          )}

          {/* ClaimResponse Errors Section */}
          {errorRemarkDetails?.length > 0 && (
            <>
              <h6 className="text-danger fs-12 mb-2">Claim Response Errors</h6>
              <ul className="mb-3 list-number">
                {errorRemarkDetails?.map((item, index) => (
                  <li key={`error-${index}`} className="text-danger fs-12">
                    <span className="fw-bold mr-2">
                      {isTag ? "(NPHIES)" : "(PAYER)"}
                    </span>{" "}
                    {item?.claimerr_code ? `(${item?.claimerr_code}) - ${item?.claimerr_display}` : item?.claimerr_display}
                  </li>
                ))}
              </ul>
            </>
          )}

          {!errorRemarkDetails?.length && !allValidationIssues?.length && (
            <div className="d-flex align-items-center fs-12 justify-content-center py-2">
              No Claims Issue Found
            </div>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default ClaimIssueRequest;
